import React, { useState, useMemo } from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import DatePicker from '../../Components/Datepicker_Basic';

/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import Commons from '../../Services/Common/Common';
function MM10080(props) {
    React.useEffect(() => {
        document.title = '생산일일현황';

        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '생산관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>생산일일현황</strong>" +
            '</h1>';
    }, []);
    const gridRef = React.useRef();
    const autoGroupColumnDef = useMemo(() => {
        //그룹설정
        return {
            headerName: '창고명',
            minWidth: 100,
        };
    }, []);
    const rowGroupPanelShow = 'always';
    const groupDefaultExpanded = 1;
    const columnDefs = [
        //창고명
        {
            field: 'whNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 70,
            rowGroup: true,
            enableRowGroup: true,
            hide: true,
            cellRenderer: Commons.CustomWhCdRenderer,
        },
        //사업장
        {
            field: 'plantNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PlantCd' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 70,
            // rowGroup: true,
            enableRowGroup: true,
            // hide: true,
            cellRenderer: Commons.CustomPlantRenderer,
        },
        //일자
        {
            field: 'date',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Date' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 60,
            // rowGroup: true,
            enableRowGroup: true,
            // hide: true,
            cellRenderer: Commons.CustomPlantRenderer,
        },
        //공정명
        {
            field: 'processNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ProcessNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
            enableRowGroup: true,
            // rowGroup: true,
            // hide: true,
        },
        //설비명
        {
            field: 'machineNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_MachineNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 200,
            enableRowGroup: true,
            // rowGroup: true,
            // hide: true,
        },
        //작업자
        {
            field: 'worker',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WorkUser' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 80,
            enableRowGroup: true,
            // rowGroup: true,
            // hide: true,
        },
        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 280,
        },
        //규격
        {
            field: 'itemStd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStd1' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
        },
        //생산수량
        {
            field: 'seqQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SeqQty' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 90,
            suppressMovable: true,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            aggFunc: 'sum',
            cellStyle: { textAlign: 'right' },
        },
        //불량수량
        {
            field: 'failQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_FailQty' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 90,
            suppressMovable: true,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            aggFunc: 'sum',
            cellStyle: { textAlign: 'right' },
        },
        //작업시간
        {
            field: 'wkDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WkDt' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
            suppressMovable: true,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            aggFunc: 'sum',
            cellStyle: { textAlign: 'right' },
        },
        //작업소요시간
        {
            field: 'processTime',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WorkingDt' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
        },
        //비고
        {
            field: 'remark',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_RemarkDtl' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 300,
        },
    ];
    return (
        <div>
            <Section />
            <Card
                wrapStyle={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    생산일자
                    <DatePicker
                        className={'datepicker-custom-input'}
                        style={{ width: '120px', marginRight: '5px', marginLeft: '5px' }}
                        selected={props.startDate}
                        onChange={(e) => {
                            props.setStartDate(e);
                        }}
                    />
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <AuthGroupButton
                        pageName="MM10080"
                        target="G01"
                        refreshNone="none"
                        selectFunc={() => {
                            props.Init();
                        }}
                        // addFunc={() =>
                        //   // gridRef.current.api.setRowData([{}, ...props.rowData])
                        //   props.setModalToggle(true)
                        // }
                        // saveFunc={() => props.SaveConfirm()}
                        // deleteFunc={() => props.DeleteConfirm()}
                    />
                </div>
            </Card>
            <Section />
            <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                <AgGridReact
                    ref={gridRef}
                    animateRows={true}
                    columnDefs={columnDefs}
                    groupIncludeTotalFooter={true}
                    autoGroupColumnDef={autoGroupColumnDef}
                    groupDefaultExpanded={groupDefaultExpanded}
                    rowGroupPanelShow={rowGroupPanelShow}
                    suppressAggFuncInHeader={true} //헤더컬럼에 sum제거
                    // autoSizeAll={autoSizeAll()}
                    defaultColDef={{
                        flex: 1,
                        editable: false,
                        resizable: true,
                        sortable: true,
                        filter: true,
                        floatingFilter: true,
                    }}
                    cellDataType={false}
                    onCellValueChanged={(e) => GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)}
                    rowData={props.rowData}
                    rowSelection="single"
                    onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)}
                    getRowStyle={(e) => (e.data ? GridFunctions.getRowStyle(e) : '')}
                />
            </div>
        </div>
    );
}

export default MM10080;
